<template>
  <div class="_md:flex _md:flex-row gap-4">

    <!-- Image -->
    <div class="module-item inline-block align-top mr-1">
      <div class="flex flex-col ">

        <div class="course-title text-sm font-bold p-0.5 text-white border-b-2 border-white"
             :style="{background: module.courses.color}"
        >
          <!-- ({{module.post.ID}}) -->
          {{ module.post.post_title }}
          <!-- [{{ register_course_id }}] -->
        </div>
        <div class="image-box w-full" :style="{'background-image': 'url(' + module.image +')'}" style="background-position: center; background-size: cover;"></div>
        <div class="flex flex-row items-center justify-between px-1 border-t border-b border-white"
             :style="{background: module.courses.color2}">

          <div v-if="userLoggedIn" class="p-1 text-sm" >{{ __('No registration') }}</div>
          <Checkbox v-if="userLoggedIn && canUnregister" :checked="isNoRegister()" :color="module.courses.color" @select="selectNoRegister()"/>
          <div v-if="userLoggedIn && !canUnregister">-</div>

          <div v-if="!userLoggedIn" class="text-sm p-1">{{ __('Not logged in') }}</div>

        </div>

      </div>
    </div>

    <!-- Courses -->
    <div v-for="course in module.courses.list" class="module-item mt-2 md:mt-0 inline-block align-top mr-1">

      <div class="course-title text-sm font-bold p-0.5 text-white border-b-2 border-white"
           :style="{background: module.courses.color}">
        {{ course.name }} {{ module.post.post_title}}
      </div>

      <div class="grid grid-cols-5 text-sm items-center" :style="{background: module.courses.color2}">

        <div class="text-sm col-span-3 p-0.5 border-r border-white" :style="styleForRow()">{{ __('Date') }}</div>
        <div class="text-sm col-span-2 p-0.5 text-center" :style="styleForRowRight()">{{ dateFormatted(course.date) }}</div>

        <div class="text-sm col-span-3 p-0.5 border-r border-white" :style="styleForRow()">{{ __('Time') }}</div>
        <div class="text-sm2 col-span-2 p-0.5 text-center" :style="styleForRowRight()">{{ to24Hour(course.hour_start) }}-{{ to24Hour(course.hour_end) }}</div>

        <div class="text-sm col-span-3 p-0.5 border-r border-white" :style="styleForRow()">{{ __('Last register') }}</div>
        <div class="text-sm col-span-2 p-0.5 text-center" :style="styleForRowRight()">
          <span v-if="!hasExpired(course)">{{ dateFormatted(lastDateToRegister(course)) }}</span>
          <span v-else class="font-bold">{{ __('Expired') }}</span>
        </div>

        <div class="text-sm col-span-3 p-0.5 border-r border-white" :style="styleForRow()">{{ __('Max users') }}</div>
        <div class="text-sm col-span-2 p-0.5 text-center" :style="styleForRowRight()">{{ course.max_users }}</div>

        <div class="text-sm col-span-3 p-0.5 border-r border-white" :style="styleForRow()">
          <span v-if="loading">...</span>
          <a v-if="!loading" href="#" @click.prevent="showListOfUsers(course)">{{ __('Current users') }}</a>
        </div>
        <div class="text-sm col-span-2 p-0.5 text-center" :style="styleForRowRight()">{{ course.users }}</div>

        <div class="text-sm col-span-3 p-0.5 border-r border-white" :style="styleForRow()">{{ __('My register') }}</div>
        <div class="text-sm col-span-2 p-0.5 text-center" :style="styleForRowRight()">
          <div v-if="!userLoggedIn">{{ __('Not logged in') }}</div>
          <div v-else class="flex flex-row items-center justify-center">
            <Checkbox :checked="isRegistered(course)" :color="module.courses.color" :expired="hasExpired(course)" @select="selectCourse(course)"/>
          </div>
        </div>

        <div class="text-sm col-span-3 p-0.5 border-r border-white" :style="styleForRow()">{{ __('Invitation') }}</div>
        <div class="text-sm col-span-2 p-0.5 text-center" :style="styleForRowRight()">
          <a v-if="course.pdf_link.length > 5" :href="course.pdf_link"
             class="no-underline" :style="{color: module.courses.color}" target="_blank"
          >{{ __('PDF') }}</a>
          <div v-else>-</div>
        </div>

      </div>

    </div>

  </div>

  <Modal v-if="show_popup">
    <div class="card bg-white shadow rounded-lg mb-6 w-[820px] max-w-full mt-10 relative">

      <div @click="show_popup = false" class="absolute top-2 right-2 cursor-pointer">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>

      <div class="p-6 text-center" style="height: 600px; overflow-y: scroll;" v-html="list_html"></div>

    </div>
  </Modal>

</template>

<script>
import Translate from "@shared/mixin/Translate";
import UtilsDateTime from "@shared/mixin/UtilsDateTime";
import Checkbox from "./Checkbox";
import Requests from "@shared/mixin/Requests";
import Modal from "./Modal";

export default {
  emits: ['count-users-changed'],
  components: {Checkbox, Modal},
  mixins: [Translate, UtilsDateTime, Requests],

  props: {
    module: {
      required: true,
    }
  },

  data(){
    return {
      register_course_id: false,
      register_date: false,
      loading: false,
      show_popup: false,
      list_html: ''
    }
  },

  mounted(){
    this.loadUserRegisterCourse()
  },

  computed: {
    userLoggedIn(){
      return window.MODUL.user.ID > 0
    },
    courseSelected() {
      let courseSelected = false

      for (let i = 0; i < this.module.courses.list.length; i++){
        if (this.module.courses.list[i].id == this.register_course_id){
          courseSelected = this.module.courses.list[i]
        }
      }

      return courseSelected
    },
    canUnregister()
    {
      let courseSelected = this.courseSelected
      if (!courseSelected) return true

      return this.register_course_id && !this.hasExpired(courseSelected)
    }
  },

  methods: {

    loadUserRegisterCourse() {
      // Load the course the user is registered
      let user_courses = window.MODUL.user_courses
      let list_courses = this.module.courses.list

      for (let i = 0; i < user_courses.length; i++){
        if (user_courses[i].post_id == this.module.post.ID)
        {
          let user_course = user_courses[i]
          for (let j = 0; j < list_courses.length; j++) {
            if (list_courses[j].date == user_course.date && list_courses[j].id == user_course.course_id) {
              this.register_course_id = user_course.course_id
              this.register_date = user_course.date
            }
          }
        }
      }
    },

    dateFormatted(date) {
      return DateTime.fromFormat(date, 'yyyy-MM-dd').toFormat('dd.MM.yyyy')
    },

    styleForRow(){
      return "border-bottom: 1px solid white;";
    },

    styleForRowRight(){
      return "border-bottom: 1px solid white; border-left: 1px solid white;";
    },

    lastDateToRegister(course) {
      let date = DateTime.fromFormat(course.date, 'yyyy-MM-dd')
      let numDays = parseInt( course.close_days_before )
      return date.plus({days: - numDays }).toFormat('yyyy-MM-dd')
    },

    hasExpired(course) {
      let now = DateTime.now().toFormat('yyyy-MM-dd')
      let lastDate = this.lastDateToRegister(course)
      return now > lastDate
    },

    isComplete(course) {
      return parseInt(course.users) >= parseInt(course.max_users)
    },

    isRegistered(course) {
      return course.id == this.register_course_id
    },

    isNoRegister() {
      return this.register_course_id === false
    },

    selectCourse(course) {

      if (this.register_course_id && this.hasExpired(this.courseSelected)) {
        Swal.fire(this.__('You cannot change course'))
        return
      }

      if (this.hasExpired(course)) {
        Swal.fire(this.__('This course has expired'))
        return
      }

      if (this.isComplete(course)) {
        Swal.fire(this.__('This course is full'))
        return
      }


      this.register_course_id = course.id
      this.register_date = course.date
      this.save()
    },

    selectNoRegister() {
      this.register_course_id = false
      this.register_date = false
      this.save()
    },

    save() {
      var data = {
        action: 'save_modul_user_register',
        user_id: window.MODUL.user.ID,
        modul_id: this.module.post.ID,
        register_course_id: this.register_course_id,
        register_date: this.register_date
      }

      this.ajaxRequest(data, (data) => {
          //console.log(data.countUsers)
          this.$emit('count-users-changed', data.countUsers)
      }, (data) => {

      })
    },

    showListOfUsers(course) {
      this.requestUsers(course)
    },

    requestUsers(course) {
      var data = {
        action: 'get_course_html_users',
        modul_id: this.module.post.ID,
        course_id: course.id
      }

      this.loading = true

      this.ajaxRequest(data, (response) => {
        this.loading = false

        //console.log(response.html)
        //this.managePrintHtml(response.html)

        this.list_html = response.html
        this.show_popup = true

      }, (data) => {
        this.loading = false
      })
    },


    managePrintHtml(html) {
      var list_window = window.open('users','ListWindow','width=800,height=800,scrollbars');
      //var list_window = window.open('','ListWindow');
      list_window.document.open();
      //list_window.document.write('<!doctype html>');
      list_window.document.write(html);
      list_window.document.close();
      //list_window.print();
    }

  }
}
</script>

<style>
.module-item { width: 195px; max-width: 195px; overflow-x: hidden; vertical-align: top; }
.module-item .image-box { height: 134px; }
.course-title { color: white !important; }
.text-sm { font-size: 12px !important; color: black; line-height: 1.20rem !important; }
.text-sm2 { font-size: 11px !important; color: black; line-height: 1.20rem !important; }
.p-0\.5 { padding: 1px !important; }
@media (max-width: 420px) {
  #app-courses { margin: auto; }
  .module-item { width: 100%; max-width: 100%; }
}
.card table { border-left: none; }
.card td { border: none; text-align: left; }
</style>
